/*
 * Avisos push en este dispositivo: suscribirse, darse de baja y volver a registrar
 * la suscripción al abrir la app (por si el navegador la renovó o cambió quién entra).
 * Quien manda los avisos es la API, después de cada cambio de otra persona.
 */

import { api } from "./cliente";

export const pushSoportado = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const appInstalada = () =>
  window.matchMedia("(display-mode: standalone)").matches || (navigator as { standalone?: boolean }).standalone === true;

function bytesDeBase64Url(b64: string): Uint8Array<ArrayBuffer> {
  const s = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  const bytes = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) bytes[i] = s.charCodeAt(i);
  return bytes;
}

export async function suscripcionActual(): Promise<PushSubscription | null> {
  if (!pushSoportado()) return null;
  // getRegistration y no `ready`: si el service worker no se pudo registrar, `ready` no resuelve nunca.
  const registro = await navigator.serviceWorker.getRegistration();
  return registro ? registro.pushManager.getSubscription() : null;
}

export async function activarAvisos(): Promise<void> {
  // Primero, todavía dentro del toque: iOS solo pide permiso desde un gesto del usuario.
  const permiso = await Notification.requestPermission();
  if (permiso !== "granted") throw new Error("Sin permiso para notificar. Actívalo en Ajustes → Notificaciones → Nexlum.");
  if (!(await navigator.serviceWorker.getRegistration())) await navigator.serviceWorker.register("/sw.js");
  const registro = await navigator.serviceWorker.ready;
  const { llave } = await api<{ llave: string }>("/api/notificaciones/llave");
  const s = (await registro.pushManager.getSubscription())
    ?? (await registro.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytesDeBase64Url(llave) }));
  await api("/api/notificaciones/suscripcion", { body: s.toJSON() });
}

export async function desactivarAvisos(): Promise<void> {
  const s = await suscripcionActual();
  if (!s) return;
  await api("/api/notificaciones/suscripcion/baja", { body: { endpoint: s.endpoint } });
  await s.unsubscribe();
}

export async function refrescarSuscripcion(): Promise<void> {
  const s = await suscripcionActual();
  if (s && Notification.permission === "granted") await api("/api/notificaciones/suscripcion", { body: s.toJSON() });
}
